import { Injectable } from '@angular/core';


@Injectable()
export class StorageService {


	isLogged:boolean=false;
	constructor() {

	}


	setID(id:any) {
      localStorage.setItem("userID", id);
	}
	setSessionId(id:any){
     sessionStorage.setItem("loginID",id);
	}
	getSessionId(){
		sessionStorage.getItem("loginID");
	   }

	getID() {
      return localStorage.getItem("userID");
	}
	removeID() {
      localStorage.removeItem("userID");
      localStorage.removeItem("sessionId");
  }

  cleanSession = () => {
    //localStorage.clear();
  }

  setCompliance(data: any) {
    localStorage.setItem("Compliance", JSON.stringify(data));
  }
  getCompliance() {
    return JSON.parse(localStorage.getItem("Compliance"));
  }

  clearCompliance() {
    //console.log("Compliance cleared");
    localStorage.removeItem("Compliance");
  }





}
